import { z } from 'zod';

// Resposta de GET /api/v2/agentes/autoaprendizado (parser lib/learnings-parser.js).
// Campos podem vir null quando o arquivo não trouxe o dado.

const n = z.coerce.number().nullable();
const s = z.string().nullable();

export const regraSchema = z.object({
  id: s,
  category: s,
  priority: s,
  status: s,
  area: s,
  summary: s,
  pattern_key: s,
  source: s,
  tags: z.array(z.string()).default([]),
  recurrence: n,
  first_seen: s,
  last_seen: s,
  promoted: s,
  application_count: n,
  last_applied: s,
});
export type Regra = z.infer<typeof regraSchema>;

export const erroSchema = z.object({
  data: s,
  titulo: s,
  pattern_key: s,
  category: s,
  priority: s,
  recurrence: n,
  last_seen: s,
  status: s,
  what_happened: s,
  do_differently: s,
  promoted: s,
});
export type Erro = z.infer<typeof erroSchema>;

export const featureSchema = z.object({
  id: s,
  slug: s,
  priority: s,
  status: s,
  area: s,
  capability: s,
  complexity: s,
  frequency: s,
  pattern_key: s,
  decision: s,
});
export type Feature = z.infer<typeof featureSchema>;

export const autoaprendizadoSchema = z.object({
  gerado_em: s,
  resumo: z.object({
    nota_estrutura: n,
    nota_obediencia: n,
    cobertura_evidencia_pct: n,
    regras_promovidas: n,
    em_quarentena: n,
    quebras_ativas: n,
    erros_ativos: n,
    feature_backlog: n,
    pattern_key_duplicados: n,
    pendencias_brutas: n,
  }),
  impacto: z.object({ critical: z.coerce.number().default(0), medium: z.coerce.number().default(0), low: z.coerce.number().default(0) }),
  obediencia: z.object({
    regras_auditadas: n,
    com_sinal_memoria: n,
    sem_evidencia_suficiente: n,
    sem_evidencia_apos_quarentena: n,
    quebras_potenciais: n,
  }),
  alertas: z.array(z.string()).default([]),
  quarentena: z.array(z.object({ pattern_key: z.string(), resumo: z.string() })).default([]),
  regras: z.array(regraSchema).default([]),
  erros: z.array(erroSchema).default([]),
  features: z.array(featureSchema).default([]),
});
export type Autoaprendizado = z.infer<typeof autoaprendizadoSchema>;
